export default __webpack_public_path__ + "static/moderate-f9018dd2221b4453ebdf220b540ed5ca.png";